import { useDateTimeFormat } from '@core/shared/src/hooks/useDateTimeFormat';
import { WebinarDataWithAssets } from '@core/swagger-client';
import { Heading } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const AuthFormBroadcasterHeader = ({ webinar }: { webinar: WebinarDataWithAssets }) => {
    const { t } = useTranslation();
    const { date: webinarDate } = useDateTimeFormat(webinar.broadcastDateTime, { date: 'DDD | t' });

    return (
        <div>
            {t('Pages.Register.WebinarBroadcaster')}
            <Heading variant="h3" classNames="my-4">
                {webinar.title}
            </Heading>
            <div>{webinarDate}</div>
            <hr className="border-primary border-dashed my-6 w-full max-w-96" />
            <div className="italic mt-2 mb-4 md:mb-10">{t('Pages.Register.WebinarBroadcaster.CreateAccount')}</div>
        </div>
    );
};
